import { dapiFetch, IDapiRequest } from "@origin-digital/daxi";
import { readStorage, writeStorage } from "./storage";

export type FetchUserHashResponse = { userHash?: string };

export type PlatformType = "IOS" | "ANDROID" | "WEB";

export const fetchUserHash = async (
  platformType: PlatformType,
  isNative: boolean
): Promise<FetchUserHashResponse> => {
  //try from storage first
  const userHashfromStorage = readStorage(isNative).userHash;
  if (userHashfromStorage) {
    return { userHash: userHashfromStorage };
  } else {
    const endpoint = `https://${window.location.host}/api/intercom/v2/contacts`;
    const payload: IDapiRequest = {
      body: { platformType },
      method: "POST",
      authorization: "jwt",
    };
    const { data } = await dapiFetch<FetchUserHashResponse>(endpoint, payload);
    //update storage
    const res = data?.userHash;
    if (res) {
      writeStorage({ userHash: res }, isNative);
    }
    return { userHash: res };
  }
};
